<template>
  <div class="posterName">
    <div>
      <UserOutlined :style="{ fontSize: '1.4em' }" />
    </div>
    <div>
      <p :style="{ fontSize: fontSize.p + 'em' }">
        &ensp;{{ data.posterName ? "投稿者" : "資料來源" }}:{{
          data.posterName ? data.posterName : data.source
        }}
      </p>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
import { UserOutlined } from "@ant-design/icons-vue";
export default {
  name: "Source",
  components: {
    UserOutlined,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          pageId: "",
          nodeId: "",
          posterName: "",
          auther: "",
          source: "",
        };
      },
    },
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.posterName {
  display: flex;
  align-items: flex-end;
}
</style>
